import { inject, Injectable } from '@angular/core';
import { I18nService } from '../../../core/services/i18n.service';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';
import { LeadFormData } from '../../interfaces/lead-form/lead-form-data';

@Injectable({
  providedIn: 'root'
})
export class LeadFormBaseToTableDataMapperService {

  i18n = inject(I18nService);

  constructor() { }

  public map(leadFormData: LeadFormData): DialogTableDataRow[] {

    let dialogTableDataRows: DialogTableDataRow[] = [
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'CUSTOMERNAME',
        value: leadFormData.name,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'ORGANIZATIONTYPE',
        value: this.i18n.i18nLng()[leadFormData.organisationType],
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'STREETNR',
        value: leadFormData.streetNr,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'ADDRESS2LABEL',
        value: leadFormData.addressLine2,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'POSTALCODE',
        value: leadFormData.postalCode,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'CITY',
        value: leadFormData.city,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'EMAILADDRESS',
        value: leadFormData.email,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PHONE',
        value: leadFormData.phone,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'WEBSITEURL',
        value: leadFormData.url,
      },
    ];

    return dialogTableDataRows;

  }
}
